import { useCallback } from 'react'
import { PersonalizedVariant, Variant } from '@phrasee/phrasee-typings'
import copy from 'copy-to-clipboard'
import { ResponseVariant } from 'workflow/Insights/Insights'
import { openTweakLine } from 'workflow/Workflow.actions'

import { successToast } from 'common/components/toastNotification'
import { useAppDispatch } from 'common/hooks/redux'

const useTableActions = () => {
  const dispatch = useAppDispatch()

  const onCopy = useCallback((text: string) => {
    copy(text)
    successToast('Variant copied successfully')
  }, [])

  const onRequestChange = useCallback(
    (variant: ResponseVariant | Variant | PersonalizedVariant) => {
      const variantId =
        'sl_id' in variant
          ? variant.sl_id
          : 'variant_id' in variant
          ? variant.variant_id
          : variant._id
      dispatch(openTweakLine({ ...variant, _id: variantId }))
    },
    [dispatch]
  )

  return {
    onCopy,
    onRequestChange,
  }
}

export default useTableActions
